module.exports = __webpack_public_path__ + "img/logo.47cde31f.svg";